const Hls = require('hls.js')

export default function video() {
  // See: https://docs.mux.com/guides/video/play-your-videos
  // and https://www.npmjs.com/package/hls.js
  // Then make it work for multiple videos on a page
  var videoEl = document.querySelectorAll('.Video-player');
  videoEl.forEach(item => {
    // get src from data attribute
    var videoSrc = item.dataset.src;
    // hls.js is not supported on platforms that do not have Media Source
    // Extensions (MSE) enabled.
    //
    // When the browser has built-in HLS support (check using `canPlayType`),
    // we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video
    // element through the `src` property. This is using the built-in support
    // of the plain video element, without using hls.js.
    //
    // Note: it would be more normal to wait on the 'canplay' event below however
    // on Safari (where you are most likely to find built-in HLS support) the
    // video.src URL must be on the user-driven white-list before a 'canplay'
    // event will be emitted; the last video event that can be reliably
    // listened-for when the URL is not on the white-list is 'loadedmetadata'.
    // Some browers (safari and ie edge) support HLS natively, so first check for native browser HLS support 
    if (item.canPlayType('application/vnd.apple.mpegurl')) {
      item.src = videoSrc;
      item.addEventListener('loadedmetadata', function() {
        this.play();
      });
    }
    // If no native HLS support, check if hls.js is supported
    else if (Hls.isSupported()) {
      var hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(item);
      // hls.on(Hls.Events.MANIFEST_PARSED, function() {
      //   video.play();
      // });
      // Avoid autoplay attribute and use play method instead
      // See: https://docs.mux.com/guides/video/web-autoplay-your-videos#avoid-the-autoplay-attribute
      item.play().then(() => {
        // autoplay was successful!
        console.log('Autoplay success!');
      }).catch((error) => {
         // autoplay was unsuccessful!
        console.warning('Autoplay error', error);
      });
    }
  });
}